<div
    class="flex flex-col space-y-2 lg:space-y-0 lg:flex-row lg:space-x-3 lg:max-h-[75vh]"
>
    <div class="flex lg:w-80 overflow-scroll">
        <app-coordination-results-tree
            [dataSource]="treeDataSource"
            [selectedNode]="treeSelectedNode"
            (leafSelected)="onTreeLeafSelected($event.node)"
        ></app-coordination-results-tree>
    </div>
    <div class="flex flex-col lg:min-h-[75vh] lg:w-3/4">
        @if (treeSelectedNodeScheduleDAndH) {
            <app-coordination-result-schedule-d-and-h-info
                class="mb-2"
                [scheduleDAndH]="treeSelectedNodeScheduleDAndH"
            ></app-coordination-result-schedule-d-and-h-info>

            <app-grid-toolbar
                [gridApi]="gridApi"
                [options]="gridToolbarOptions"
            ></app-grid-toolbar>
            <div class="lg:flex-grow">
                <ag-grid-angular
                    [context]="initializeGridContext()"
                    [gridOptions]="gridOptions"
                    (gridReady)="onGridReady($event)"
                    class="ag-theme-quartz h-[65vh] lg:h-100p"
                >
                </ag-grid-angular>
            </div>
        } @else {
            <div class="flex flex-col space-y-3 text-center my-5">
                <h1 class="!text-xl text-tertiary-700 !font-normal !m-0">
                    Select a Frequency
                </h1>
                <h2 class="!text-base text-tertiary-700 !font-normal !m-0">
                    Select a frequency to view the coordination request details.
                </h2>
            </div>
        }
    </div>
</div>
